const formatCurrency = (priceStr) => {
    var price = priceStr ? parseFloat(priceStr) : null
    if (price) {
        var fixedStr = price.toFixed(2).toString().replace('.', ',')
        var splited = fixedStr.split(',')
        return splited[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (splited[1] != '00' ? ',' + splited[1] : '')
    }
    return null
}

export default formatCurrency